module.exports = __webpack_public_path__ + "img/WHY-TRADE-WITH-US.970e92e4.png";